/*
 * @Author: 小周
 * @Date: 2022-05-30 15:30:49
 * @LastEditTime: 2022-05-30 15:47:47
 * @LastEditors: MrZHLF 480970024@qq.com
 * @Description: H5分享页面
 */
import wx from 'weixin-js-sdk';
import axios from 'axios';
import { shareLink, shareTitle, shareDesc, shareImg, appId } from './weChatShare_conf';

export function H5WeChat_init(obj) {
	console.log(obj)
	let formData = new FormData();
	formData.append('url', window.location.href.split('#')[0]);
	formData.append('appid', appId);
	axios({
		url: 'https://weizan.dianzhenkeji.com/api/jssdk.php',
		method: 'post',
		data: formData,
		dataType: 'json',
	})
		.then((res) => {
			let { code, data } = res.data;
			console.log(res, 'res');
			if (code == 0) {
				wx.config({
					debug: false,
					appId: data.appId,
					timestamp: data.timestamp,
					nonceStr: data.nonceStr,
					signature: data.signature,
					jsApiList: [
						'checkJsApi',
						'onMenuShareQQ',
						'onMenuShareWeibo',
						'onMenuShareQZone',
						'onMenuShareTimeline',
						'onMenuShareAppMessage',
					],
				});
			}
		})
		.catch((err) => {
			console.log(err);
		});

	wx.ready(() => {
		wx.onMenuShareTimeline({
			title: obj.shareTitle || shareTitle,
			desc: obj.shareDesc || shareDesc,
			link: obj.shareLink || shareLink,
			imgUrl: obj.shareImg || shareImg,
			success: (res) => {
				// 分享朋友圈
				console.log(res);
			},
			cancel: () => {},
		});

		wx.onMenuShareAppMessage({
			title: obj.shareTitle || shareTitle,
			desc: obj.shareDesc || shareDesc,
			link: obj.shareLink || shareLink,
			imgUrl: obj.shareImg || shareImg,
			success: (res) => {
				// 分享好友
				console.log(res, 'onMenuShareAppMessage');
			},
			cancel: function () {},
		});
		wx.onMenuShareWeibo({
			title: obj.shareTitle || shareTitle,
			desc: obj.shareDesc || shareDesc,
			link: obj.shareLink || shareLink,
			imgUrl: obj.shareImg || shareImg,
			success: (res) => {
				console.log(res, 'onMenuShareWeibo');
			},
			cancel: () => {},
		});

		wx.onMenuShareQZone({
			title: obj.shareTitle || shareTitle,
			desc: obj.shareDesc || shareDesc,
			link: obj.shareLink || shareLink,
			imgUrl: obj.shareImg || shareImg,
			success: (res) => {
				// QQ空间
				console.log(res);
			},
			cancel: () => {},
		}),
			wx.onMenuShareQQ({
				title: obj.shareTitle || shareTitle,
				desc: obj.shareDesc || shareDesc,
				link: obj.shareLink || shareLink,
				imgUrl: obj.shareImg || shareImg,
				success: (res) => {
					// 分享QQ
					console.log(res);
				},
				cancel: () => {},
			});
	});
}
